import {
  GapEnum,
  Stack,
} from '@delmonicos/shared-design-system-react/src/components/stack/stack';
import { useGetCustomersPaginatedFormValidation } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/customers/models/get-customers-paginated.form-validation';
import { GetCustomersPaginatedModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/customers/models/get-customers-paginated.model';
import { Controller, useFormContext } from 'react-hook-form';

import { CustomerIsExemptFromBillingFilterController } from '../../customer-is-exempt-from-billing-filter/customer-is-exempt-from-billing-filter.controller';

const CustomerListFilterFormStep1IsExemptFromBillingFragment =
  (): React.JSX.Element => {
    // CONTEXT /////////////////////////////////////////////////////////////////

    // const { t } = useTranslation();
    const { control } = useFormContext<GetCustomersPaginatedModel>();
    const { isExemptFromBilling } = useGetCustomersPaginatedFormValidation();

    // RENDER ////////////////////////////////////////////////////////////////////

    return (
      <Stack gap={GapEnum.L} flex={1} direction="column">
        <Controller
          name="isExemptFromBilling"
          control={control}
          rules={isExemptFromBilling}
          render={({ field /* , fieldState: { error } */ }) => {
            return (
              <CustomerIsExemptFromBillingFilterController
                checked={field.value}
                onChange={(e) => field.onChange(e.target.checked)}
              />
            );
          }}
        />
      </Stack>
    );
  };

export const CustomerListFilterFormStep1Controller = (): React.JSX.Element => {
  // RENDER //////////////////////////////////////////////////////////////////

  return (
    <Stack
      direction="row"
      justifyContent="stretch"
      alignItems="stretch"
      flex={1}
      gap={GapEnum.XL}>
      <Stack direction="column" flex={1} alignItems="stretch" gap={GapEnum.XL}>
        <CustomerListFilterFormStep1IsExemptFromBillingFragment />
      </Stack>
    </Stack>
  );
};
